import { h } from 'preact';
import * as BaseComp from 'components/bolt/landscapeOverlay/landscapeOverlay.js';
import Store from 'store/store';
import s from 'components/bolt/landscapeOverlay/landscapeOverlay.sss';

export default class LandscapeOverlay extends BaseComp.default {

	render() {
		const imageRoot = Store.get()?.appData?.urls?.roots?.image;
		return (
			<div class={s.container}>
				<img class={s.icon} src={`${imageRoot}/rotate-phone.png`} alt="" />
				<span class={s.text}>Turn your device to
					<span class={s.boldText}>Portrait Mode</span>
				</span>
			</div>
		);
	}
}
